<template>
  <div>
    <vue-headful title="Credimóvil | Contacto"/>
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area">
    	<div class="container">
    		<h6>Si tienes dudas</h6>
    		<h2>Contáctanos</h2>
    		<ol class="breadcrumb">
                <li><a href="/">Inicio</a></li>
                <li><a href="/contact" class="active">Contacto</a></li>
            </ol>
    	</div>
    </section>
    <!-- Banner Area -->

    <!-- Contact info Area -->
    <section class="contact_info">
    	<div class="container">
    		<div class="row">
    			<div class="col-lg-4 col-md-6">
    				<div class="info">
    					<i class="flaticon-call"></i>
                        <h6>Phone : <a href="tel:3310782828"><br>33 1078 2828</a></h6>
    				</div>
    			</div>
    			<div class="col-lg-4 col-md-6">
    				<div class="info mail">
    					<i class="flaticon-mail"></i>
    					<h6>Email : <a href="mailto:contacto@gpiautocomercial.com.mx">contacto@gpiautocomercial.com.mx</a></h6>
    				</div>
    			</div>
    			<div class="col-lg-4 col-md-6">
    				<div class="info placeholder">
    					<i class="flaticon-placeholder-1"></i>
    					<h6>Av. Las Rosas 2991, Col. Chapalita,<br> C.P. 44510, Guadalajara, Jalisco </h6>
    				</div>
    			</div>
    		</div>
    	</div>
    </section>
    <!-- Contact info Area -->

    <!-- Map and From Area -->
    <section class="map_from_area">
        <div class="map_area">
            <div class="map_content">
                <iframe src="https://www.google.com/maps/d/u/0/embed?mid=15t3qJqAwN9WTPYplZFk1lDq5Y4N_FqVK"
                    height="671" frameborder="0" style="border:0; width: 100%" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
        </div>
        <div class="contact_inner contact-form-title">
            <form class="from_main" action="php/contact.php" method="post" id="phpcontactform" novalidate="novalidate">
                <h2>¿Tienes alguna pregunta que hacer? <br><span>por favor, escríbenos</span> </h2>
                <div class="form-group">
                    <input type="text" class="form-control" id="name" name="name" placeholder="Nombre" v-model="contactForm.name" :class="{ 'error': $v.contactForm.name.$invalid }">
                </div>
                <div class="form-group">
                    <input type="email" class="form-control" id="email" name="email" placeholder="Correo electrónico" v-model="contactForm.email" :class="{ 'error': $v.contactForm.email.$invalid }">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" id="subject" name="subject" placeholder="Asunto" v-model="contactForm.subject" :class="{ 'error': $v.contactForm.subject.$invalid }">
                </div>
                <div class="form-group">
                    <textarea class="form-control" id="message" name="message" placeholder="Mensaje" v-model="contactForm.text" :class="{ 'error': $v.contactForm.text.$invalid }"></textarea>
                </div>
                <div class="form-group">
                    <button class="theme_btn btn" id="js-contact-btn" type="button" v-on:click="sendContact()" :disabled="$v.contactForm.$invalid">Enviar</button>
                    <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div>
                </div>
            </form>
        </div>
    </section>
    <!-- End Map and From Area -->

    <!-- Sucursales -->
    <section class="sucursal-ubicacion">
        <div class="container">
            <div class="spacer-title">
                <h3>Actualmente contamos con oficinas en varias</h3>
                <h3><span>ciudades de la República</span> tales como:</h3>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <span><b>GUADALAJARA</b> (Matriz)</span>
                        <p>GPI AUTO COMERCIAL SAPI DE C.V.</p>
                        <p>Av. de las Rosas No. 2991, Col. Chapalita.</p>
                        <p>CP 44500, Guadalajara, Jal.</p>
                        <p><a href="tel:3310782828">Tel: (33) 1078 2828</a></p><br>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <span><b>CDMX</b></span>
                        <p>Luz Saviñon No. 2007,</p>
                        <p>Piso 3, Oficina 309, Col. Narvarte Poniente.</p>
                        <p>Del. Benito Juárez, CP. 03020</p>
                        <p><a href="tel:5555250476">Tel: (55) 5525 0476</a></p><br>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <span><b>ESTADO DE MÉXICO</b> (TOLUCA)</span>
                        <p>Av. Gobernadores #52. Despacho 7.</p>
                        <p>Col. La Providencia, CP. 52177</p>
                        <p><a href="tel:7229146374">Tel: (722) 914 6374</a></p>
                        <p><a href="tel:7224987715">Cel: (722) 4987 715</a></p><br>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <span><b>COLIMA</b></span>
                        <p> Av. Camino Real No. 652,</p>
                        <p>Altos Col. El Porvenir</p>
                        <p>CP. 28019</p>
                        <p><a href="tel:3121595795">Tel: (312) 159 5795</a></p><br>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <span><b>GUANAJUATO</b> (LEÓN)</span>
                        <p> Calle Fuego No. 501, Int. 108.</p>
                        <p>Col. Jardines del Moral</p>
                        <p>CP. 37160</p>
                        <p><a href="tel:4772517893">Cel: Tel: (477) 251 7893</a></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Sucursales -->

    <!-- Get started -->
    <section class="get_started_area">
      <div class="container">
        <h2>¿Preparado para comenzar?</h2>
        <p>Inicia tu trámite a través de nuestra plataforma</p>
        <a href="/pre-approval" class="theme_btn">Aplicar ahora</a>
      </div>
    </section>
      <!-- End get started -->
  </div>
</template>

<script>
  import { required, minLength, between } from 'vuelidate/lib/validators';

  export default {
    name: 'Contact',
    data() {
      return {
        contactForm: {
          name: '',
          email: '',
          subject: '',
          text: '',
        }
      }
    },
    validations() {
      return {
        contactForm: {
          name: { required },
          email: { required },
          subject: { required },
          text: { required }
        }
      }
    },
    methods: {
      sendContact() {
        var data = {
          data: {
            name: this.contactForm.name,
            email: this.contactForm.email,
            subject: this.contactForm.subject,
            message: this.contactForm.text,
          }
        };
        this.$InsuranceService.sendContact(data).then((result) => {
          alert('Exito, su petición ha sido enviada con exito');
          window.location = '/';
        }, (err) => {
          alert(err.msg);
        });
      },
    },
  }
</script>

<style lang="scss">

  .error {
    border-color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue